import { UnitConversionFactor } from "./UnitConversionFactor";
import { UnitConversionFactorGroup } from "./UnitConversionFactorGroup";
import { VolumeUnits } from "./VolumeUnits";

export class VolumeConversionFactors {
    public static readonly IG_TO_L =
        new UnitConversionFactor(4.54609, VolumeUnits.IMP_GALLON, VolumeUnits.LITER);
    public static readonly IG_TO_UG =
        new UnitConversionFactor(1.20095, VolumeUnits.IMP_GALLON, VolumeUnits.US_GALLON);

    public static readonly L_TO_IG =
        new UnitConversionFactor(0.2199693, VolumeUnits.LITER, VolumeUnits.IMP_GALLON);
    public static readonly L_TO_UG =
        new UnitConversionFactor(0.264172, VolumeUnits.LITER, VolumeUnits.US_GALLON);

    public static readonly UG_TO_IG =
        new UnitConversionFactor(0.8326743, VolumeUnits.US_GALLON, VolumeUnits.IMP_GALLON);
    public static readonly UG_TO_L =
        new UnitConversionFactor(3.785412, VolumeUnits.US_GALLON, VolumeUnits.LITER);

    private static readonly group = new UnitConversionFactorGroup(this.IG_TO_L, this.IG_TO_UG, this.L_TO_IG,
        this.L_TO_UG, this.UG_TO_IG, this.UG_TO_L);

    public static get(): UnitConversionFactorGroup {
        return this.group;
    }
}
